import { useState } from "react";
import { Button, ButtonProps, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

import CircularLoader from "../CircularLoader";

export interface ConfirmDialogProps {
  body: React.ReactNode;
  closeLabel?: string;
  confirmColor?: ButtonProps["color"];
  confirmLabel?: string;
  onConfirm: () => void | Promise<void>;
  onClose: () => void;
  open: boolean;
  shouldSetLoading?: boolean;
  title: string;
}

function ConfirmDialog(props: ConfirmDialogProps) {
  const {
    body,
    closeLabel = "Cancel",
    confirmColor = "primary",
    confirmLabel = "Ok",
    onConfirm,
    onClose,
    open,
    shouldSetLoading = true,
    title,
  } = props;

  const [loading, setLoading] = useState(false);

  const handleConfirm = async (): Promise<void> => {
    if (shouldSetLoading) {
      setLoading(true);
    }

    await onConfirm();

    if (shouldSetLoading) {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth='xs'
      onClose={onClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>{title}</DialogTitle>
      <DialogContent>{body}</DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{closeLabel}</Button>
        <CircularLoader loading={loading}>
          <Button onClick={handleConfirm} color={confirmColor} disabled={loading}>
            {confirmLabel}
          </Button>
        </CircularLoader>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmDialog;
